import React from "react";

import { IconButton, StyleProps } from "@chakra-ui/react";

import { FaSyncAlt } from "react-icons/fa";

import { useCrudListContext } from "./CrudListContext";

export interface CrudListRefreshButtonProps extends StyleProps {}

export const CrudListRefreshButton: React.FC<CrudListRefreshButtonProps> = ({
  ...styleProps
}) => {
  const { isManualLoading, refreshList } = useCrudListContext();

  return (
    <IconButton
      aria-label="Refresh"
      icon={<FaSyncAlt />}
      isDisabled={isManualLoading}
      onClick={refreshList}
      {...styleProps}
    />
  );
};
